import Attachment from './attachment';
import Code from './code-highlight';
import Image from './image';
import Link from './link';
import BlockCollapse from './block-collapse';
import ToolCall from './tool-call';
import StepProcess from './step-process';
import Paragraph from './paragraph';
import TakeOver from './take-over';
import Loading from './loading';
import SchedulerForm from './scheduler-form';
import SchedulerTaskCard from './scheduler-task-card';
import DeepResearchClar from './deep-research-clar';
import SchedulerRunNotification from './scheduler-run-notification';
import WebCard from './web-card';
export default [
  Attachment,
  Image,
  WebCard,
  Link,
  Code,
  BlockCollapse,
  ToolCall,
  StepProcess,
  Paragraph,
  TakeOver,
  SchedulerForm,
  SchedulerTaskCard,
  DeepResearchClar,
  SchedulerRunNotification,
  Loading,
];
